module.exports = __webpack_public_path__ + "static/media/testimonials-man.284b3dd2.svg";